import { RemoveRedEyeOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useDialog } from '@prismamedia/one-components';
import { useApolloClient } from '@apollo/client';
import { FC, MouseEvent, useCallback } from 'react';
import { GET_ARTICLE_URL_STATUS } from '../../apollo/queries/articles.web.graphql';
import { PublicationStatusDialog } from '../PublicationStatusDialog';

const SEE_PUBLIC_SITE = 'Voir en front';

interface SeeArticleButtonProps {
  articleId: string;
  publicUrl: string;
}

export const SeeArticleButton: FC<SeeArticleButtonProps> = ({
  articleId,
  publicUrl,
}) => {
  const { openDialog, closeDialog } = useDialog();
  const client = useApolloClient();

  const handleClick = useCallback(
    async (event: MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();

      if (config.ENV === 'REC2') {
        window.open(publicUrl);
        return;
      }

      try {
        const result = await client.query({
          query: GET_ARTICLE_URL_STATUS,
          variables: { where: { id: articleId } },
          fetchPolicy: 'network-only',
        });

        const urlStatus = result?.data?.article?.urls?.[0]?.status?.ok;

        if (urlStatus) {
          window.open(publicUrl);
          return;
        }

        openDialog(
          <PublicationStatusDialog url={publicUrl} onClose={closeDialog} />,
          { maxWidth: 'sm' },
        );
      } catch {
        openDialog(
          <PublicationStatusDialog url={publicUrl} onClose={closeDialog} />,
          { maxWidth: 'sm' },
        );
      }
    },
    [articleId, client, closeDialog, openDialog, publicUrl],
  );

  return (
    <Tooltip title={SEE_PUBLIC_SITE}>
      <IconButton
        aria-label={SEE_PUBLIC_SITE}
        data-testid="seeArticle"
        onClick={handleClick}
        size="small"
        sx={{
          color: grey[500],
          mr: 0.25,
          p: 0,
        }}
      >
        <RemoveRedEyeOutlined sx={{ fontSize: 20 }} />
      </IconButton>
    </Tooltip>
  );
};
